import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.announcement').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.announcement', {
                abstract: true,
                component: 'contentLayout',
                resolve: {
                    communities:getCommunities,
                },
            })
            .state('app.announcement.list', {
                url: '/announcement/list', views: {
                    content: {
                        component: 'announcementList',
                    },
                },
            })
            .state('app.announcement.create', {
                url: '/announcement/create', views: {
                    content: {
                        component: 'announcementDetails',
                    },
                },
                params: {
                    id: null,
                    forDuplication: false,

                },
            })

            .state('app.announcement.update', {
                url: '/announcement/:id',
                views: {
                    content: {
                        component: 'announcementDetails',
                    },
                },
                params: {
                    id: null,
                    forDuplication: false,

                },
            })
            .state('app.announcement.duplicate', {
                url: '/announcement/duplicate/:id',
                views: {
                    content: {
                        component: 'announcementDetails',
                    },
                },
                params: {
                    id: null,
                    forDuplication: true,
                },
            })
    }
})();

getAnnouncement.$inject = ['$transition$', 'AnnouncementSvc'];
function getAnnouncement($transition$, AnnouncementSvc) {
    return AnnouncementSvc.getAnnouncement($transition$.params().id);
}

getCommunities.$inject = [ 'CommunityDA'];
function getCommunities (CommunityDA) {
    return CommunityDA.getAllSimpleCommunities();
}